"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceNotFound = void 0;
const ResponseError_1 = require("./ResponseError");
class ResourceNotFound extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.message = this.message || ResourceNotFound.label;
        this.type = ResourceNotFound.type;
        this.name = this.constructor.name;
        this.statusCode = ResourceNotFound.statusCode;
        Error.captureStackTrace(this, ResourceNotFound);
    }
}
exports.ResourceNotFound = ResourceNotFound;
ResourceNotFound.type = 'NotFound';
ResourceNotFound.label = 'Not Found';
ResourceNotFound.statusCode = 404;
//# sourceMappingURL=ResourceNotFound.js.map